import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateUser } from "@/lib/api/user";
import { USER_QUERY_KEY, useUserQuery } from "@/hooks/use-user";
import type { UserSettingsRequest } from "@/types/user-settings";

interface UseUserSettingsQueryOptions {
  enabled?: boolean;
}

export const useUserSettingsQuery = (
  options: UseUserSettingsQueryOptions = {}
) => useUserQuery({ ...options, select: (user) => user.settings ?? null });

export const useUpdateUserSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // PATCH /dashboard/user merges the nested settings object.
    mutationFn: (data: UserSettingsRequest) =>
      updateUser({ settings: data }).then((res) => res.data),
    onSuccess: async (user) => {
      // A GET already in flight could land after this and put the old
      // settings back, so cancel it before writing the PATCH response.
      await queryClient.cancelQueries({ queryKey: USER_QUERY_KEY });
      queryClient.setQueryData(USER_QUERY_KEY, user);
    },
  });
};
